"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.spacing = exports.sharedColors = exports.isAlwaysNativeDropDownMenu = exports.iconSizes = exports.components = void 0;
var _AuthButton = _interopRequireDefault(require("./AuthButton.theme"));
var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup.theme"));
var _ButtonGroupItem = _interopRequireDefault(require("./ButtonGroupItem.theme"));
var _Card = _interopRequireDefault(require("./Card.theme"));
var _Checkbox = _interopRequireDefault(require("./Checkbox.theme"));
var _Chip = _interopRequireDefault(require("./Chip.theme"));
var _Dialog = _interopRequireDefault(require("./Dialog.theme"));
var _FlatButton = _interopRequireDefault(require("./FlatButton.theme"));
var _Form = _interopRequireDefault(require("./Form.theme"));
var _MessageBar = _interopRequireDefault(require("./MessageBar.theme"));
var _Modal = _interopRequireDefault(require("./Modal.theme"));
var _Nav = _interopRequireDefault(require("./Nav.theme"));
var _Pagination = _interopRequireDefault(require("./Pagination.theme"));
var _Paper = _interopRequireDefault(require("./Paper.theme"));
var _Popover = _interopRequireDefault(require("./Popover.theme"));
var _RaisedButton = _interopRequireDefault(require("./RaisedButton.theme"));
var _Select = _interopRequireDefault(require("./Select.theme"));
var _SideMenu = _interopRequireDefault(require("./SideMenu.theme"));
var _SideMenuSubmenu = _interopRequireDefault(require("./SideMenuSubmenu.theme"));
var _Snackbar = _interopRequireDefault(require("./Snackbar.theme"));
var _Tab = _interopRequireDefault(require("./Tab.theme"));
var _Table = _interopRequireDefault(require("./Table.theme"));
var _TableHeader = _interopRequireDefault(require("./TableHeader.theme"));
var _Tag = _interopRequireDefault(require("./Tag.theme"));
var _Text = _interopRequireDefault(require("./Text.theme"));
var _TextInput = _interopRequireDefault(require("./TextInput.theme"));
var _Toggle = _interopRequireDefault(require("./Toggle.theme"));
var _sharedThemeSettings = require("../../themes/sharedThemeSettings");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var spacing = exports.spacing = {
  base: 8
};
var iconSizes = exports.iconSizes = {
  small: 20,
  medium: 24,
  large: 32
};
var sharedColors = exports.sharedColors = _objectSpread({
  primary: "#0dadbb",
  primaryDark: "#0e848e",
  primaryLight: "#16d6e6",
  alert: "#c53212",
  warning: "#e6ad28",
  success: "#7ab329",
  info: "#00adbb",
  active: "#0dadbb",
  activeVariant: "#195b1e",
  // NOTE: component lib and some applications (chat.client, search.client, performer.server, scp) using these colors for background and fill for svg icons
  // It seems to indicate that we have a need for that type of scenarios and should probably expand our variables
  textOnDark: "#ffffff",
  textOnLight: "#212121",
  baseInvariant: "#94949e",
  baseShadow: "rgba(0, 0, 0, 0.5)",
  // Should gold colors not be a part of every theme, and only belong to `whitelabel` theme?
  // Within component library only used in RaisedButton for gold variant of the button
  // Note, colors are used directly in hybrid.client, chat.client
  gold: "#ffc107",
  // this is a weird one, it's not used within components,
  // but we can't remove it without major version bump as it might be used in individual projects
  goldVariant: "#8F680A",
  goldGradient: "linear-gradient(to bottom, #fbe112 0%, #cc7d00 100%)",
  goldGradientHover: "linear-gradient(to bottom, #fde83d, #f19502)",
  messenger: "#0B84FF"
}, _sharedThemeSettings.brandColors);
var typography = exports.typography = {
  fontFamily: 'Lato, Roboto, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: 1.45
};
var isAlwaysNativeDropDownMenu = exports.isAlwaysNativeDropDownMenu = true;
var components = exports.components = {
  AuthButton: _AuthButton.default,
  ButtonGroup: _ButtonGroup.default,
  ButtonGroupItem: _ButtonGroupItem.default,
  Card: _Card.default,
  Checkbox: _Checkbox.default,
  Chip: _Chip.default,
  Dialog: _Dialog.default,
  FlatButton: _FlatButton.default,
  Form: _Form.default,
  MessageBar: _MessageBar.default,
  Modal: _Modal.default,
  Nav: _Nav.default,
  Pagination: _Pagination.default,
  Paper: _Paper.default,
  Popover: _Popover.default,
  RaisedButton: _RaisedButton.default,
  Select: _Select.default,
  SideMenu: _SideMenu.default,
  SideMenuSubmenu: _SideMenuSubmenu.default,
  Snackbar: _Snackbar.default,
  Tab: _Tab.default,
  Table: _Table.default,
  TableHeader: _TableHeader.default,
  Tag: _Tag.default,
  Text: _Text.default,
  TextInput: _TextInput.default,
  Toggle: _Toggle.default
};